import { formatNumber } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import SectionCard from "../SectionCard";

type Stop = {
  min_check_number: string;
  max_check_number?: string;
  amount?: number;
};

interface StopPaymentRequestProps {
  stop: Stop;
}
const StopPaymentRequest = ({ stop }: StopPaymentRequestProps) => {
  const { l10n } = useLocalization();

  return (
    <div className="requests-card-subsection-item">
      {l10n.getString(
        "label-stop-payment-request",
        {
          checkNumber: stop.min_check_number,
          checkRange: stop.max_check_number ? "true" : "false",
          maxCheckNumber: stop.max_check_number || "",
          hasAmount: stop.amount ? "true" : "false",
          amount: stop.amount ? formatNumber(stop.amount / 100) : "",
        },
        `Check-${stop.min_check_number}${stop.max_check_number ? ` to Check-${stop.max_check_number}` : ""}${stop.amount ? ` for ${formatNumber(stop.amount / 100)}` : ""}`
      )}
    </div>
  );
};

interface RequestsCardProps {
  isLoading: boolean;
  stopPayments: Stop[];
}

const RequestsCard = ({ isLoading, stopPayments }: RequestsCardProps) => {
  const { l10n } = useLocalization();

  return (
    <SectionCard isLoading={isLoading}>
      {stopPayments.length > 0 && (
        <>
          <SectionCard.Title text={l10n.getString("requests-header")} />
          <div className="requests-card-subsection-title">{l10n.getString("requests-stop-payment-header")}</div>
          {stopPayments.map((stop) => (
            <StopPaymentRequest key={JSON.stringify(stop)} stop={stop} />
          ))}
        </>
      )}
    </SectionCard>
  );
};

export default RequestsCard;
